import en from './en/index';

export default {
    en
};
